export function TeamLogo({ team, size = 32 }) {
  if (team.logo) {
    return <img src={team.logo} alt={team.name} width={size} height={size} className="object-contain shrink-0" style={{ width: size, height: size }} loading="lazy" />;
  }
  return <div className="shrink-0 border border-white/10" style={{ width: size, height: size, background: team.color }} />;
}

export function FormBadges({ form = [], testId, size = "sm" }) {
  const cls = size === "sm" ? "w-4 h-4 text-[9px]" : "w-5 h-5 text-[10px]";
  const label = { W: "V", D: "N", L: "P" };
  return (
    <div className="flex gap-0.5" data-testid={testId}>
      {form.slice(-5).map((r, i, arr) => {
        const bg = r === "W" ? "bg-[#39FF14]" : r === "D" ? "bg-[#A1A1AA]" : "bg-[#FF3B30]";
        return <span key={`${arr.length - i}-${r}`} className={`${bg} ${cls} text-black grid place-items-center font-black`}>{label[r] || r}</span>;
      })}
    </div>
  );
}
